import React from 'react';
import { useSyncStatus } from '../../contexts/SyncStatusContext';
import { formatDateTimeShort } from '../../utils/formatDateTime';

const GROUP_LABELS = {
  orders: '受発注',
  inventory: '在庫',
  master: 'マスタ',
};

/**
 * サイドバー下部の最終同期サマリーとアラート。
 * @param {{ sidebarOpen: boolean }} props
 */
export const SyncStatusSidebar = ({ sidebarOpen }) => {
  const { status } = useSyncStatus();

  const ordersAt = status?.groups?.orders?.last_finished_at;
  const inventoryAt = status?.groups?.inventory?.last_finished_at;
  const masterAt = status?.groups?.master?.last_finished_at;
  const alerts = status?.alerts || [];
  const hasAlerts = alerts.length > 0;

  if (!sidebarOpen) {
    return (
      <div className="px-2 py-2 border-t border-slate-700" title={hasAlerts ? alerts.map((a) => a.message).join('\n') : '最終同期'}>
        <div className={`w-3 h-3 rounded-full mx-auto ${hasAlerts ? 'bg-amber-400' : 'bg-slate-600'}`} />
      </div>
    );
  }

  return (
    <div className="mb-3 pb-3 border-b border-slate-700 text-xs text-slate-400 space-y-1">
      <div className="text-slate-500 font-medium uppercase tracking-wide text-[10px]">最終同期</div>
      <div className="flex justify-between gap-2">
        <span>受発注</span>
        <span className="text-slate-300">{formatDateTimeShort(ordersAt)}</span>
      </div>
      <div className="flex justify-between gap-2">
        <span>在庫</span>
        <span className="text-slate-300">{formatDateTimeShort(inventoryAt)}</span>
      </div>
      <div className="flex justify-between gap-2">
        <span>マスタ</span>
        <span className="text-slate-300">{formatDateTimeShort(masterAt)}</span>
      </div>
      {hasAlerts && (
        <div className="mt-2 space-y-1">
          {alerts.map((alert) => (
            <div key={alert.key} className="text-amber-300 leading-snug">
              {alert.message}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
